import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Switch, Route, withRouter } from "react-router";
import { useLocation } from "react-router-dom";
import track from "react-tracking";
import ReactGA from "react-ga4";
import UpsellPage from "Root/quiz/components/upsell/upsellPage/index";
import toastService from "Root/profile/toastService";
import { apiGetStripeKeys, apiRemoveLineItem, apiAddAdditionalItemToNextOrder } from "Root/api/apiCheckout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import QuizPage from "./components/quizPage";
import QuizLoading from "./components/QuizLoading";
import QuizStartFuture from "./components/QuizStartFuture";
import QuizStart from "./components/QuizStart";
import { HyroxResults } from "./components/HyroxResults";
import TargetLandingPage from "./components/Target/TargetLandingPage";
import TargetResultsPage from "./components/Target/TargetResultsPage";
import QuizTargetStart from "./components/QuizTargetStart";
import RdMacroTool from "Root/profile/components/RdMacroTool";
import posthog from "posthog-js";
import { pageView } from "../helpers/helper";
import Cookies from "js-cookie";
import DebugMenu from "Components/DebugMenu";
export const QuizContext = React.createContext({});
const quizRoutes = () => {
    const [userCart, setUserCart] = useState({
        userCart: [],
        missingAddons: [],
    });
    const [dietaryOpt, setDietaryOpt] = useState("");
    const [exerciseTime, setExerciseTime] = useState("");
    const [weeklyFreq, setWeeklyFreq] = useState("");
    const [sweatName, setSweatName] = useState("");
    const [flavorsInfo, setFlavorsInfo] = useState(null);
    const [addonFlavors, setAddonFlavors] = useState({
        hydration: [],
        preworkout: [],
        protein: [],
        flavorCounts: {},
        flavorLimits: {},
    });
    const [addonAttributes, setAddonAttributes] = useState(null);
    const [stripePromise, setStripePromise] = useState(null);
    const [updatingUserCart, setUpdatingUserCart] = useState(false);
    const empty_cart = {
        protein: 0,
        hydration: 0,
        preworkout: 0,
        creatine: 0,
        collagen: 0,
        fiber: 0,
        blenderbottle: 0,
        waterbottle: 0,
    };
    const [updatingItems, setUpdatingItems] = useState([]);
    const [cart, setCartState] = useState(empty_cart);
    const [address, setAddress] = useState({
        firstName: "",
        lastName: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        email: "",
    });
    const setCart = useCallback((newCart) => {
        setCartState(newCart);
    }, [setCartState]);
    let location = useLocation();
    useEffect(() => {
        pageView(location.pathname);
    }, [location.pathname]);
    useEffect(() => {
        const sessionid = Cookies.get("sessionid");
        if (sessionid) {
            posthog?.identify(sessionid);
        }
    }, []);
    useEffect(() => {
        const attributes = {
            preworkout: [],
            hydration: [],
        };
        userCart?.userCart?.forEach((item) => {
            if (item.item_type in ["hydration", "preworkout"]) {
                attributes[item.item_type] = item.attributes;
            }
        });
        setAddonAttributes(attributes);
    }, [userCart]);
    function error_message(msg) {
        toastService.errorMessage(msg);
    }
    function updateCart(item, value) {
        const cart_copy = { ...cart };
        cart_copy[item] = value;
        setCart(cart_copy);
        setUpdatingUserCart(false);
        const newItems = [...updatingItems].filter((itemName) => itemName !== item);
        setUpdatingItems(newItems);
    }
    async function addItemToCart(item, callb) {
        const newItems = [...updatingItems];
        newItems.push(item);
        setUpdatingItems(newItems);
        setUpdatingUserCart(true);
        const data = { item };
        try {
            const resp = await apiAddAdditionalItemToNextOrder(data);
            // @ts-ignore
            setUserCart(resp.userCart);
            toastService.successMessage(`Added ${resp.item_name} to cart.`);
            setUpdatingUserCart(false);
            setUpdatingItems([...updatingItems.filter((itemName) => itemName !== item)]);
            callb && callb();
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
            updateCart(item, 0);
            callb && callb();
        }
    }
    async function removeItemFromCart(item) {
        setUpdatingUserCart(true);
        const data = { item_key: item };
        try {
            const resp = await apiRemoveLineItem(data);
            // @ts-ignore
            setUserCart(resp.userCart);
            toastService.successMessage(`Removed ${resp.item_name} from cart.`);
            updateCart(item, 0);
        }
        catch (e) {
            updateCart(item, 1);
        }
    }
    const contextObject = useMemo(() => ({
        userCart,
        setUserCart,
        dietaryOpt,
        setDietaryOpt,
        exerciseTime,
        setExerciseTime,
        weeklyFreq,
        error_message,
        setWeeklyFreq,
        cart,
        setCart,
        addonAttributes,
        setAddonAttributes,
        flavorsInfo,
        setFlavorsInfo,
        sweatName,
        setSweatName,
        addItemToCart,
        removeItemFromCart,
        updatingUserCart,
        addonFlavors,
        setAddonFlavors,
        address,
        setAddress,
    }), [
        userCart,
        cart,
        setCart,
        sweatName,
        setSweatName,
        setUserCart,
        dietaryOpt,
        setDietaryOpt,
        exerciseTime,
        addonAttributes,
        setAddonAttributes,
        error_message,
        setExerciseTime,
        weeklyFreq,
        setWeeklyFreq,
        flavorsInfo,
        addItemToCart,
        removeItemFromCart,
        setFlavorsInfo,
        updatingUserCart,
        addonFlavors,
        setAddonFlavors,
        address,
        setAddress,
    ]);
    const fetchStripeKeys = async () => {
        try {
            const data = await apiGetStripeKeys();
            setStripePromise(loadStripe(data.publicKey));
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
    };
    useEffect(() => {
        fetchStripeKeys();
    }, []); // Only run once
    const scriptOne = `!function(){var geq=window.geq=window.geq||[];if(geq.initialize) return;if (geq.invoked){if (window.console && console.error) {console.error("GE snippet included twice.");}return;}geq.invoked = true;geq.methods = ["page", "suppress", "trackOrder", "identify", "addToCart", "callBack", "event"];geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);args.unshift(method);geq.push(args);return geq;};};for (var i = 0; i < geq.methods.length; i++) {var key = geq.methods[i];geq[key] = geq.factory(key);}geq.load = function(key){var script = document.createElement("script");script.type = "text/javascript";script.async = true;if (location.href.includes("vge=true")) {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";}var first = document.getElementsByTagName("script")[0];first.parentNode.insertBefore(script, first);};geq.SNIPPET_VERSION = "1.6.1";
geq.load("350H9NW5");}();`;
    function unloadScript(scriptElement) {
        document.head.removeChild(scriptElement);
    }
    function loadScriptOne() {
        const script = document.createElement("script");
        script.textContent = scriptOne; // Your script text
        script.async = true;
        document.head.appendChild(script);
        return script;
    }
    useEffect(() => {
        const script = loadScriptOne();
        return () => {
            unloadScript(script);
        };
    }, []);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    useEffect(() => {
        if (window && window.geq && !scriptLoaded) {
            window.geq.page();
            setScriptLoaded(true);
        }
    }, [window.geq, scriptLoaded]);
    return (_jsxs(Elements, { stripe: stripePromise, children: [_jsx(QuizContext.Provider, { value: contextObject, children: _jsxs(Switch, { children: [_jsx(Route, { path: "/quiz-new/:quizName", component: QuizPage }), _jsx(Route, { path: "/quiz-new/:quizName/:questionName?", component: QuizPage }), _jsx(Route, { path: "/users/checkout/", component: QuizLoading }), _jsx(Route, { path: "/users/me", component: QuizLoading }), _jsx(Route, { path: "/quiz-start/", component: QuizStart }), _jsx(Route, { path: "/quiz-start-future/", component: QuizStartFuture }), _jsx(Route, { path: "/quiz-start-target/", component: QuizTargetStart }), _jsx(Route, { path: "/products/", component: UpsellPage }), _jsx(Route, { path: "/rdsupport/", component: TargetLandingPage }), _jsx(Route, { path: "/target-results-page/", component: TargetResultsPage }), _jsx(Route, { path: "/macro-tool/", component: RdMacroTool }), _jsx(Route, { path: "/hyrox-results/", component: HyroxResults })] }) }), _jsx(DebugMenu, {})] }));
};
const TrackedQuizApp = track({ Component: "quiz_app" }, {
    dispatch: (data) => {
        ReactGA.event({
            category: data.funComponent,
            action: data.event,
        });
    },
})(withRouter(quizRoutes));
export default TrackedQuizApp;
